import { render, staticRenderFns } from "./quickEntityAddWidget.vue?vue&type=template&id=2e8bec63"
import script from "./quickEntityAddWidget.vue?vue&type=script&lang=js"
export * from "./quickEntityAddWidget.vue?vue&type=script&lang=js"
import style0 from "./quickEntityAddWidget.vue?vue&type=style&index=0&id=2e8bec63&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports